declare var __GlobalSettings: any;

export const UrlConstants = {
    //baseUrl: "https://trdev01.ticketreturn.com/BoxOfficeAPI-TRMobile-MultiSponsor/",
    //mobileUrl: "https://trdev01.ticketreturn.com/TRMobile-MultiSponsor/",
    tokenBOUrl: __GlobalSettings.ApiUrl,

    teamLogoPath: __GlobalSettings.ImagesUrl,
    appStoreUrl: "https://apps.apple.com/us/app/varsitytix/id1534347131",
    googlePlayUrl: "https://play.google.com/store/apps/details?id=com.ticketreturn.varsitytix&hl=en_CA&gl=US",


    //ticketReturn : "https://www.ticketreturn.com",
    //printTickets : "https://www.ticketreturn.com/prod3/Print",
    //transferTickets : "https://www.ticketreturn.com/prod3/Transfer",
    //ticketsForSale : "https://www.ticketreturn.com/prod3/Sell",
    //exchangeTickets : "https://www.ticketreturn.com/prod3/",
    //donateTickets : "https://www.ticketreturn.com/prod3/",
    //viewTickets : "https://www.ticketreturn.com/prod3/",
    //aboutMarketing : "http://marketing.ticketreturn.com",
    //desktopVersion: "https://www.ticketreturn.com/prod2/?Mobile=0",

    //signIn: "http://trdev01.ticketreturn.com/prod2/account.asp"

}
//"https://trdev01.ticketreturn.com/BoxOfficeAPI-TRMobile-VarsityTix/api/Sponsor/GetSHSponsorsByATV?X-Token=8ca2d0a877036923fcae011311c3082052080d20412a37b50863dc26fde7d8c5&ATV=houston"



// WEBPACK FOOTER //
// ./src/commons/constants/urls.ts